import { AnimatedProgress, AnimatedNumber } from "@/lib/animations";

interface DistanceStatCardProps {
  totalDistance: number;
}

export function DistanceStatCard({ totalDistance }: DistanceStatCardProps) {
  return (
    <div className="col-span-1 rounded-4xl bg-white/5 border border-white/5 p-4 flex flex-col justify-between relative overflow-hidden group">
      <div className="absolute top-0 right-0 p-3 opacity-20 group-hover:opacity-40 transition-opacity">
        <span className="material-symbols-outlined text-4xl text-primary">
          route
        </span>
      </div>
      <p className="text-sm font-medium text-white/50">
        Total Distance
      </p>
      <div className="mt-2">
        <p className="text-3xl font-extrabold text-white tracking-tight">
          <AnimatedNumber value={totalDistance} decimals={1} />
        </p>
        <p className="text-xs font-bold text-white/40 uppercase">
          Kilometers
        </p>
      </div>
      <div className="mt-3">
        <AnimatedProgress
          value={100}
          className="bg-primary h-full rounded-full shadow-[0_0_10px_rgba(37,244,120,0.5)]"
          trackClassName="w-full bg-white/10 rounded-full h-1"
          delay={0.3}
        />
      </div>
    </div>
  );
}
